import(/* webpackMode: "eager" */ "/home/luckym/Frontend/repo-superadmin-panel-hevmed/src/app/not-found.tsx");
